module.exports = __webpack_public_path__ + "img/ctrl-r-theta-stub-up-+.3bfb9ce2.svg";